export default __webpack_public_path__ + "static/media/354.4dbf3ffb.jpg";